<mat-toolbar
  class="toolbar"
  [class.impersonating]="loggedInUserIsImpersonating"
  [ngStyle]="{
    'box-shadow': isAlertBannerPresent ? 'none' : '0 2px 6px rgb(0 0 0 / 30%)',
  }"
  role="banner"
>
  @if (!suppressNavMenu) {
    <button
      class="sidenav-button has-icon"
      mat-button
      data-testid="main-nav-button"
      [attr.data-intercom-target]="intercomLabels.NAV_MENU"
      (click)="sideNavClicked()"
    >
      <img [src]="logoPath$ | async" class="header-logo" alt="" />
      <span class="sidenav-label mat-title-small">menu</span>
      <emperor-icon
        class="sidenav-icon"
        [name]="isSideNavOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
      ></emperor-icon>
    </button>
  } @else {
    <img [src]="logoPath$ | async" class="header-logo loading" alt="" />
  }

  <div class="left-menu-content">
    @if (loggedInUserIsImpersonating) {
      <div class="impersonating-user" data-testid="impersonating">
        Impersonating {{ nameOfUserBeingImpersonated$ | async }}
      </div>
    }
  </div>
  <div class="center-menu-content">
    @if (loggedInUserIsImpersonating) {
      <emperor-link-button [href]="JiraCreateBugPage" target="_blank">
        <span class="create-bug-text">Create Bug</span>
      </emperor-link-button>
    }
    @if (isExchangeTenantType$ | async) {
      <div class="exchange-type-promo">
        <span class="bold">Read only</span>To get the full Terminal experience
        schedule a demo today
      </div>
    }
  </div>
  <div class="right-menu-content">
    <app-profile-menu class="profile-menu-container"></app-profile-menu>
    @if (intercomEnabled$ | async) {
      <address class="intercom-container">
        <button
          id="intercom-launcher"
          mat-button
          emperorTooltip="Need help?"
          tooltipPlacement="bottom"
          aria-label="Chat for help"
          (click)="intercomActive ? onHideIntercom() : onShowIntercom()"
          [ngClass]="{ active: intercomActive }"
          class="has-icon"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-hidden="true"
            width="25"
            height="24"
            fill="#fff"
            fill-rule="nonzero"
            xmlns:v="https://vecta.io/nano"
          >
            <path
              d="M15.998 16v2H8.66l-2.67 2v-2h-3V9h6V7h-6a2 2 0 0 0-2 2v9c0 1.1.897 2 2 2h1v4l5.333-4h6.66c1.1 0 2-.9 2-2v-2h-2 .015zm1.992-2a7.01 7.01 0 0 1-7-7 7.01 7.01 0 0 1 7-7 7.01 7.01 0 0 1 7 7 7.01 7.01 0 0 1-7 7zm0-12c-2.76 0-5 2.24-5 5a5.01 5.01 0 0 0 5 5c2.75 0 5-2.25 5-5a5.01 5.01 0 0 0-5-5zm-1 5h2v4h-2zm1-3a1 1 0 1 0 0 2 1 1 0 1 0 0-2z"
            />
          </svg>
        </button>
      </address>
    }
  </div>
</mat-toolbar>
